import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Field } from 'redux-form';

import { CrossChunky } from '@eb/eds-iconography';
import { EventCard } from '@eb/event-renderer';
import { IconButton } from '@eb/eds-icon-button';

import './EventCardGroupEdit.scss';

const renderEventCardField = ({ input, events, isEditMode }) => {
    const { onChange } = input;
    const inputValue = input.value || [];

    const checkboxes = events.map(({ id, ...eventProps }, index) => {
        const handleChange = () => {
            const arr = [...inputValue];

            if (!inputValue.includes(id)) {
                arr.push(id);
            } else {
                arr.splice(arr.indexOf(id), 1);
            }
            return onChange(arr);
        };
        const checked = inputValue.includes(id);
        let style = 'outline';

        if (checked) {
            style = 'inverse';
        }

        return (
            <li
                key={`collection-event--edit-${index}`}
                className="collection-event--edit"
            >
                <IconButton
                    iconType={<CrossChunky />}
                    style={style}
                    isActive={true}
                    onClick={handleChange}
                    title="collection-event-selector"
                />
                <div
                    className={classnames(
                        'eds-l-pad-hor-2',
                        'eds-l-pad-vert-1',
                        'collection-event__event-card-container',
                        {
                            'collection-event__event-card-container--unclickable': isEditMode,
                        },
                        {
                            'collection-event__event-card-container--faded': checked,
                        },
                    )}
                >
                    <EventCard
                        id={id}
                        eventData={eventProps}
                        type="list"
                        hideSaveButton={true}
                        excludeDateThumbnail={true}
                    />
                </div>
            </li>
        );
    });

    return <ul className="eds-g-group">{checkboxes}</ul>;
};

export default class EventCardGroupEdit extends PureComponent {
    render() {
        return (
            <Field
                {...this.props}
                type="checkbox"
                component={renderEventCardField}
            />
        );
    }
}
